/* Ardor Banner Builder: Text, Clipart and exact-logo layers (sticker builder style) and the AI banner hand-off. Ardor Printing.
   New Oct 8, 2026. Load after ardor-banner-builder-v3.js and ardor-banner-app.js (sections/ardor-banner-builder-v3.liquid).
   Talks to the builder only through window.ArdorBannerAPI (v3) and gives it
   window.ArdorBannerLayers = { paint, composite, has, list }.
   Layers live in banner inches (objects centered on left/top) on a Fabric.js canvas laid exactly over the 2D layout canvas,
   one set per face (front, and back when the back has different art). Fabric loads on first use. */
(function () {
  'use strict';
  if (window.ArdorBannerLayers) return;

  var IDEA_PAGE = '/pages/ai-banner-generator';
  var IDEA_API = 'https://ws-idea-api.dayne-18a.workers.dev';
  var FONT_CSS = 'https://fonts.googleapis.com/css2?family=Unbounded:wght@200..900&family=Anton&family=Bangers&family=Bebas+Neue&family=Black+Ops+One&family=Bree+Serif&family=Comic+Neue:wght@700&family=Homemade+Apple&family=Italiana&family=Lobster&family=Monoton&family=Orbitron:wght@800&family=Pacifico&family=Permanent+Marker&family=Quicksand:wght@700&family=Righteous&family=Rubik+Mono+One&family=Satisfy&family=Special+Elite&display=swap';
  // same fonts and clipart as the sticker builder (ardor-sticker-studio.js)
  var FONTS = [['Arial', 'Arial'], ['Unbounded', 'Unbounded'], ['Jost', 'Jost'], ['Anton', 'Anton'], ['Bebas Neue', 'Bebas Neue'], ['Black Ops One', 'Black Ops One'], ['Bangers', 'Bangers'], ['Orbitron', 'Digital'], ['Rubik Mono One', 'Rubik Mono'], ['Righteous', 'Righteous'], ['Monoton', 'Monoton'], ['Permanent Marker', 'Permanent Marker'], ['Pacifico', 'Pacifico'], ['Lobster', 'Lobster'], ['Satisfy', 'Satisfy'], ['Homemade Apple', 'Homemade Apple'], ['Special Elite', 'Special Elite'], ['Quicksand', 'Quicksand'], ['Bree Serif', 'Bree Serif'], ['Comic Neue', 'Comic Neue'], ['Italiana', 'Italiana'], ['Georgia', 'Georgia']];
  function burst(n, r12, r2) { var d = ''; for (var i = 0; i < n * 2; i++) { var r = i % 2 ? r2 : r12, a = Math.PI * i / n - Math.PI / 2; d += (i ? 'L' : 'M') + (50 + r * Math.cos(a)).toFixed(1) + ' ' + (50 + r * Math.sin(a)).toFixed(1) + ' '; } return d + 'Z'; }
  var CLIPART = [
    { cat: 'Shapes', name: 'star', d: 'M50 5 61 38 96 38 68 59 79 93 50 72 21 93 32 59 4 38 39 38Z' },
    { cat: 'Shapes', name: 'heart', d: 'M50 90C20 68 4 52 4 31 4 17 15 6 29 6c9 0 17 5 21 13 4-8 12-13 21-13 14 0 25 11 25 25 0 21-16 37-46 59Z' },
    { cat: 'Shapes', name: 'circle', d: 'M50 4a46 46 0 1 0 .1 0Z' },
    { cat: 'Shapes', name: 'square', d: 'M8 8h84v84H8Z' },
    { cat: 'Shapes', name: 'triangle', d: 'M50 6 96 90H4Z' },
    { cat: 'Shapes', name: 'hexagon', d: 'M50 4 90 27v46L50 96 10 73V27Z' },
    { cat: 'Badges', name: 'seal', d: burst(16, 48, 40) },
    { cat: 'Badges', name: 'burst', d: burst(12, 48, 30) },
    { cat: 'Badges', name: 'bubble', d: 'M12 8h76a8 8 0 0 1 8 8v46a8 8 0 0 1-8 8H46L24 92V70H12a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8Z' },
    { cat: 'Badges', name: 'ribbon', d: 'M4 30h92l-12 20 12 20H4l12-20Z' },
    { cat: 'Badges', name: 'shield', d: 'M50 4 88 18v28c0 24-16 42-38 50C28 88 12 70 12 46V18Z' },
    { cat: 'Badges', name: 'crown', d: 'M8 80 14 26l20 24 16-32 16 32 20-24 6 54Z' },
    { cat: 'Icons', name: 'bolt', d: 'M58 4 18 56h28l-8 40 44-56H54Z' },
    { cat: 'Icons', name: 'flame', d: 'M50 96c-22 0-36-16-36-36 0-20 16-30 20-48 10 12 12 22 10 32 8-8 12-18 10-30 20 14 32 32 32 48 0 20-14 34-36 34Z' },
    { cat: 'Icons', name: 'cross', d: 'M41 4h18v26h26v18H59v48H41V48H15V30h26Z' },
    { cat: 'Icons', name: 'arrow', d: 'M4 40h56V18l36 32-36 32V60H4Z' },
    { cat: 'Icons', name: 'mountain', d: 'M4 88 36 34l16 24 14-18 30 48Z' },
    { cat: 'Icons', name: 'cloud', d: 'M26 80C12 80 4 70 4 60c0-12 10-20 22-18 2-16 14-26 28-26 16 0 28 12 28 26 10 0 16 8 16 18 0 12-8 20-20 20Z' },
    { cat: 'Icons', name: 'moon', d: 'M62 6C38 12 24 32 24 54c0 24 20 42 44 42 14 0 24-6 30-14-10 4-20 4-28 2-22-6-34-26-30-46 4-16 12-26 22-32Z' },
    { cat: 'Icons', name: 'pin', d: 'M50 96S16 58 16 36C16 17 31 4 50 4s34 13 34 32c0 22-34 60-34 60Zm0-46a12 12 0 1 0 0-24 12 12 0 0 0 0 24Z' },
    { cat: 'Icons', name: 'leaf', d: 'M10 90C10 40 40 10 92 8c-2 52-32 82-82 82Z' },
    { cat: 'Icons', name: 'drop', d: 'M50 4S18 44 18 64a32 32 0 0 0 64 0C82 44 50 4 50 4Z' },
    { cat: 'Icons', name: 'music', d: 'M84 4 36 14v50a14 12 0 1 0 8 11V32l32-7v31a14 12 0 1 0 8 11Z' },
    { cat: 'Icons', name: 'sparkle', d: 'M50 0c3 27 15 42 50 50-35 8-47 23-50 50-3-27-15-42-50-50C35 42 47 27 50 0Z' }
  ];
  var S2 = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';
  var IC = {
    clip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3 7 11h10z"/><circle cx="7" cy="17" r="4"/><rect x="13" y="13" width="8" height="8" rx="1"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 1.5c.6 5 2.8 7.8 9 9.2v.6c-6.2 1.4-8.4 4.2-9 9.2h-.6c-.6-5-2.8-7.8-9-9.2v-.6c6.2-1.4 8.4-4.2 9-9.2z"/></svg>',
    x: '<svg ' + S2 + ' width="20" height="20"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    flipx: '<svg ' + S2 + '><path d="M12 3v18M8 7l-5 5 5 5M16 7l5 5-5 5"/></svg>',
    flipy: '<svg ' + S2 + '><path d="M3 12h18M7 8l5-5 5 5M7 16l5 5 5-5"/></svg>',
    forward: '<svg ' + S2 + '><path d="M12 20V4M6 10l6-6 6 6M5 21h14"/></svg>',
    backward: '<svg ' + S2 + '><path d="M12 4v16M6 14l6 6 6-6M5 3h14"/></svg>',
    duplicate: '<svg ' + S2 + '><rect x="8" y="8" width="13" height="13" rx="2"/><path d="M4 16V5a1 1 0 0 1 1-1h11"/></svg>',
    trash: '<svg ' + S2 + '><path d="M3 6h18M8 6V4h8v2M6 6l1 15h10l1-15"/></svg>',
    undo: '<svg ' + S2 + '><path d="M9 14 4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-3"/></svg>',
    redo: '<svg ' + S2 + '><path d="m15 14 5-5-5-5"/><path d="M20 9H9a5 5 0 0 0 0 10h3"/></svg>',
    left: '<svg ' + S2 + '><path d="M4 6h16M4 12h10M4 18h13"/></svg>',
    center: '<svg ' + S2 + '><path d="M4 6h16M7 12h10M5 18h14"/></svg>',
    right: '<svg ' + S2 + '><path d="M4 6h16M10 12h10M7 18h13"/></svg>',
    logo: '<svg ' + S2 + '><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m7 15 3-3 2 2 3-4 2 3"/><circle cx="8.5" cy="9" r="1.2"/></svg>'
  };
  var PROPS = ['ablKind', 'ablLabel', 'ablLogo', 'ablStroke', 'selectable', 'evented'];
  var LOOK = { transparentCorners: false, cornerColor: '#ffffff', cornerStrokeColor: '#16161b', borderColor: '#16161b', cornerStyle: 'circle', cornerSize: 13, padding: 4, borderScaleFactor: 1.2, lockScalingFlip: true };

  var API = null, fabric = null, fc = null, fabricP = null, fontsP = null, booted = false;
  var L = { front: [], back: [] }, cur = 'front', size = { Wi: 0, Hi: 0 };
  var ui = {}, hist = { list: [], i: -1, t: 0 }, renderT = 0, quiet = false, clipColor = '#dc1f2a';
  var ai = null;

  // ---------- small helpers ----------
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function nice(n) { return String(Math.round(n * 100) / 100); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function phoneLayout() { try { return window.matchMedia('(max-width: 900px)').matches; } catch (e) { return window.innerWidth <= 900; } }
  function isPhone() { try { return /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && Math.min(screen.width, screen.height) < 820); } catch (e) { return false; } }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function waitFor(fn, ms) {
    return new Promise(function (res, rej) {
      var t0 = Date.now();
      (function poll() { var v = null; try { v = fn(); } catch (e) {} if (v) return res(v); if (Date.now() - t0 > ms) return rej(new Error('timeout')); setTimeout(poll, 80); })();
    });
  }
  function hex(c) {
    if (!c || typeof c !== 'string') return '#000000';
    if (c[0] === '#') return c.length === 4 ? '#' + c.slice(1).split('').map(function (x) { return x + x; }).join('') : c.slice(0, 7);
    var m = c.match(/\d+/g);
    return m ? '#' + m.slice(0, 3).map(function (x) { return (+x).toString(16).padStart(2, '0'); }).join('') : '#000000';
  }
  function apiBase() { return String((API && API.conf && API.conf.ideaApi) || IDEA_API).replace(/\/+$/, ''); }
  function banner() { var c = API.cfg(); return { c: c, Wi: c.W * 12, Hi: c.H * 12 }; }
  // the area inside the dashed safe line, same as the builder's drawFlat (hem, pole pockets plus 1 in)
  function safeArea(c, Wi, Hi) {
    var P = c.poleSize + 0.5, top = c.pole !== 'none' ? P : (c.hem ? 1 : 0), bottom = c.pole === 'tb' ? P : (c.hem ? 1 : 0), side = c.hem ? 1 : 0;
    var ins = function (d) { return Math.max(d, 1) + 1; };
    return { x: ins(side), y: ins(top), w: Math.max(1, Wi - 2 * ins(side)), h: Math.max(1, Hi - ins(top) - ins(bottom)) };
  }
  function mkCanvas(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function toBlob(cv, type, q) {
    return new Promise(function (res) {
      try {
        if (cv.toBlob) { cv.toBlob(function (b) { res(b); }, type, q); return; }
        var d = cv.toDataURL(type, q), bin = atob(d.split(',')[1]), u = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
        res(new Blob([u], { type: type }));
      } catch (e) { res(null); }
    });
  }

  // ---------- Fabric and fonts, loaded on first use ----------
  function assetUrl(name) {
    var src = $$('script[src]').map(function (s) { return s.src; }).filter(function (u) { return /\/assets\/ardor-banner[^/]*\.js/.test(u); })[0] || (API.conf && API.conf.pdfUrl) || '';
    return src ? src.replace(/\/assets\/[^/?#]+(\?[^#]*)?$/, '/assets/' + name) : '';
  }
  function loadFabric() {
    if (window.fabric) return Promise.resolve(window.fabric);
    if (fabricP) return fabricP;
    fabricP = new Promise(function (res, rej) {
      var src = (API.conf && API.conf.fabricUrl) || assetUrl('ardor-fabric.min.js');
      if (!src) { rej(new Error('fabric url')); return; }
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { if (window.fabric) res(window.fabric); else rej(new Error('fabric')); };
      s.onerror = function () { fabricP = null; rej(new Error('fabric')); };
      document.head.appendChild(s);
    });
    return fabricP;
  }
  function ready() { return loadFabric().then(function () { return setup(); }); }
  function loadFonts() {
    if (fontsP) return fontsP;
    fontsP = new Promise(function (res) {
      var l = $('link[data-abl-fonts]') || $('link[href*="fonts.googleapis.com"][href*="Rubik+Mono+One"]');
      if (l) { res(); return; }
      l = document.createElement('link'); l.rel = 'stylesheet'; l.href = FONT_CSS; l.setAttribute('data-abl-fonts', '');
      l.onload = function () { res(); }; l.onerror = function () { res(); };
      document.head.appendChild(l);
      setTimeout(res, 4000);
    });
    return fontsP;
  }
  function fontReady(fam) {
    return loadFonts().then(function () {
      if (!document.fonts || !document.fonts.load || /^(Arial|Georgia)$/.test(fam)) return null;
      return Promise.race([document.fonts.load('64px \'' + fam + '\''), wait(4000)]).catch(function () {});
    }).then(function () { try { if (fabric && fabric.util.clearFabricFontCache) fabric.util.clearFabricFontCache(fam); } catch (e) {} });
  }

  // ---------- the overlay canvas ----------
  function setup() {
    if (fc) return fc;
    fabric = window.fabric;
    var lc = API.layoutCanvas();
    if (!fabric || !lc) throw new Error('layers: no canvas');
    ui.lc = lc; ui.frame = lc.parentNode;
    if (window.getComputedStyle(ui.frame).position === 'static') ui.frame.style.position = 'relative';
    if (fabric.Object.prototype.controls && fabric.Object.prototype.controls.mtr) fabric.Object.prototype.controls.mtr.offsetY = -30;
    if (!(fabric.Object.NUM_FRACTION_DIGITS >= 8)) fabric.Object.NUM_FRACTION_DIGITS = 8; // layers are in inches: keep undo snapshots exact
    var cv = document.createElement('canvas');
    cv.setAttribute('aria-label', 'Text and clipart on your banner');
    ui.frame.appendChild(cv);
    // the overlay covers the whole layout frame so handles stay reachable past the banner edge; items are clipped to the banner
    fc = new fabric.Canvas(cv, { preserveObjectStacking: true, selection: false, uniformScaling: true, enableRetinaScaling: true, skipOffscreen: false, stopContextMenu: true, targetFindTolerance: 4, controlsAboveOverlay: true });
    fc.clipPath = new fabric.Rect({ left: 0, top: 0, width: 1, height: 1, originX: 'left', originY: 'top', strokeWidth: 0 });
    ui.wrap = fc.wrapperEl; ui.wrap.classList.add('abl-wrap');
    ui.wrap.style.position = 'absolute';
    ui.frame.appendChild(ui.objbar);
    bindCanvas();
    hist.list = [snapshot()]; hist.i = 0;
    sync();
    return fc;
  }

  function objectsFor(face) { face = face === 'back' ? 'back' : 'front'; return fc && face === cur ? fc.getObjects() : L[face]; }
  function editable() { return !!(API && API.editFace()); }

  // keep the overlay exactly over the layout canvas, on the right face, in the banner's inches
  function sync() {
    if (!fc || !ui.lc) return;
    var b = banner(), lc = ui.lc;
    if (size.Wi && (Math.abs(b.Wi - size.Wi) > 1e-9 || Math.abs(b.Hi - size.Hi) > 1e-9)) rescale(size.Wi, size.Hi, b.Wi, b.Hi);
    size.Wi = b.Wi; size.Hi = b.Hi;
    var fw = ui.frame.clientWidth, fh = ui.frame.clientHeight, w = lc.offsetWidth;
    if (fw > 0 && fh > 0 && w > 0) {
      if (fw !== ui.w || fh !== ui.h) { fc.setDimensions({ width: fw, height: fh }); ui.w = fw; ui.h = fh; }
      var z = w / b.Wi, ox = lc.offsetLeft, oy = lc.offsetTop, v = fc.viewportTransform;
      if (!v || Math.abs(v[0] - z) > 1e-9 || v[4] !== ox || v[5] !== oy) fc.setViewportTransform([z, 0, 0, z, ox, oy]);
      if (fc.clipPath.width !== b.Wi || fc.clipPath.height !== b.Hi) { fc.clipPath.set({ width: b.Wi, height: b.Hi }); fc.clipPath.dirty = true; }
    }
    var ef = API.editFace(), show = ef || 'front';
    if (show !== cur) switchFace(show);
    var live = !!ef;
    fc.getObjects().forEach(function (o) { var on = live && o.ablKind !== 'cover'; if (o.selectable !== on) o.set({ selectable: on, evented: on }); }); // the patch under the exact logo is never picked
    if (!live && fc.getActiveObject()) fc.discardActiveObject();
    syncPointer();
    fc.calcOffset();
    fc.requestRenderAll();
    posObjbar(); syncHist();
  }
  function syncPointer() { if (ui.wrap) ui.wrap.style.pointerEvents = editable() && fc.getObjects().length ? 'auto' : 'none'; }

  // banner size changed: keep every layer at the same place relative to the banner. Each layer remembers where it was
  // at the size it was last edited at, so typing a new width and then a new height gives the same result as both at once.
  function rebase(objs, W, H) { objs.forEach(function (o) { o.ablBase = { W: W, H: H, l: o.left, t: o.top, sx: o.scaleX, sy: o.scaleY }; }); }
  function fitTo(objs, W1, H1) {
    objs.forEach(function (o) {
      var b = o.ablBase; if (!b) return;
      var rx = W1 / b.W, ry = H1 / b.H, k = Math.min(rx, ry);
      o.set({ left: b.l * rx, top: b.t * ry, scaleX: b.sx * k, scaleY: b.sy * k }); o.setCoords();
    });
  }
  function rescale(W0, H0, W1, H1) {
    ['front', 'back'].forEach(function (f) {
      var objs = objectsFor(f);
      objs.forEach(function (o) { if (!o.ablBase) rebase([o], W0, H0); });
      fitTo(objs, W1, H1);
    });
    scheduleRender();
  }
  function switchFace(f) {
    quiet = true;
    L[cur] = fc.getObjects().slice();
    fc.discardActiveObject();
    if (L[cur].length) fc.remove.apply(fc, L[cur]);
    L[f].forEach(function (o) { fc.add(o); });
    cur = f;
    quiet = false;
    syncProps();
  }

  // ---------- what the builder calls (ArdorBannerLayers) ----------
  function has(face) { return objectsFor(face).length > 0; }
  function renderObj(ctx, o) {
    var oc = o.objectCaching, vis = o.visible;
    o.objectCaching = false; o.visible = true;
    try { o.render(ctx); } catch (e) {}
    o.objectCaching = oc; o.visible = vis;
    if (oc) o.dirty = true;
  }
  // draw one face's layers into a context already scaled to banner inches (3D texture, proof, print image)
  function paint(ctx, Wi, Hi, face) {
    if (!fc) return;
    if (ui.lc && ctx.canvas === ui.lc) return; // the live overlay shows them on the 2D layout
    var objs = objectsFor(face);
    if (!objs.length) return;
    ctx.save();
    if (size.Wi && (Math.abs(Wi - size.Wi) > 1e-6 || Math.abs(Hi - size.Hi) > 1e-6)) ctx.scale(Wi / size.Wi, Hi / size.Hi);
    objs.forEach(function (o) { renderObj(ctx, o); });
    ctx.restore();
  }
  function list(face) {
    return objectsFor(face).filter(function (o) { return o.ablKind !== 'cover'; }).map(function (o) {
      if (o.ablKind === 'text') return { kind: 'text', text: o.text, font: o.fontFamily, color: hex(o.fill), label: 'Text' };
      if (o.ablKind === 'image') return { kind: 'image', logo: !!o.ablLogo, label: o.ablLabel || 'Image' };
      return { kind: 'clipart', color: hex(o.fill), label: o.ablLabel || 'Clipart' };
    });
  }
  function printPpi(Wi, Hi) {
    var cap = isPhone() ? 16e6 : 40e6;
    return Math.max(2, Math.min(120, Math.sqrt(cap / (Wi * Hi)), 16384 / Wi, 16384 / Hi));
  }
  // one flattened JPEG of the face (background, artwork and layers) for the print file
  function composite(face, Wi, Hi, art) {
    face = face === 'back' ? 'back' : 'front';
    if (art && !art.img) return Promise.reject(new Error('no artwork preview to flatten'));
    var ppi = printPpi(Wi, Hi);
    return hiResArt(art, Wi, Hi, ppi).then(function (restore) {
      return encodeFace(face, Wi, Hi, ppi, 0).then(function (r) { restore(); return r; }, function (e) { restore(); throw e; });
    });
  }
  function encodeFace(face, Wi, Hi, ppi, tries) {
    var w = Math.max(1, Math.round(Wi * ppi)), h = Math.max(1, Math.round(Hi * ppi));
    var cv = mkCanvas(w, h), ctx = cv.getContext('2d');
    if (!ctx) return Promise.reject(new Error('canvas'));
    ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
    ctx.setTransform(w / Wi, 0, 0, h / Hi, 0, 0);
    ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
    API.paintFace(ctx, Wi, Hi, face);
    return toBlob(cv, 'image/jpeg', 0.92).then(function (b) {
      cv.width = cv.height = 1;
      if ((!b || b.size > 22 * 1024 * 1024) && tries < 3) return encodeFace(face, Wi, Hi, ppi * 0.75, tries + 1);
      if (!b) throw new Error('could not make the print image');
      return { file: new File([b], 'Ardor Banner Print Art ' + (face === 'back' ? 'Back' : 'Front') + '.jpg', { type: 'image/jpeg' }), natW: w, natH: h, ppi: ppi };
    });
  }
  // PDF / AI / EPS art: draw it again from the vector file at print size, instead of the 2400 px preview
  function hiResArt(a, Wi, Hi, ppi) {
    var none = Promise.resolve(function () {});
    var av = window.ArdorBannerArtView;
    if (!a || a.kind === 'image' || !a.img || !av || !av.preview) return none;
    var file = a.src === 'eps' && a.vectorPdf ? new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }) : ((a.src === 'pdf' || a.src === 'ai') ? a.file : null);
    var g = API.artGeom(a, Wi, Hi);
    if (!file || !g) return none;
    var px = Math.min(12000, Math.round(Math.max(g.w, g.h) * ppi));
    if (px <= Math.max(a.img.width || 0, a.img.height || 0) * 1.15) return none;
    return Promise.race([av.preview(file, { maxPx: px }), wait(30000)]).then(function (r) {
      if (!r || !r.ok || !r.canvas) return function () {};
      var old = a.img; a.img = r.canvas;
      return function () { a.img = old; };
    }).catch(function () { return function () {}; });
  }

  // ---------- adding layers ----------
  function look(o) { o.set(LOOK); return o; }
  function targetFace() {
    var f = API.editFace();
    if (!f) { API.set({ face: 'front' }); f = 'front'; }
    if (ui.app && ui.app.getAttribute('data-mode') === '3d') { var m2 = $('[data-abx-mode="2d"]', ui.app); if (m2) m2.click(); }
    sync();
    return f;
  }
  function fitInside(o, s) {
    var w = o.getScaledWidth(), h = o.getScaledHeight(), k = Math.min(1, s.w / w, s.h / h);
    if (k < 1) o.scale(o.scaleX * k);
  }
  function place(o) { fc.add(o); fc.setActiveObject(o); o.setCoords(); changed(true); syncProps(); if (phoneLayout()) closeDrawer(); }
  function addText(fam) {
    return ready().then(function () { return fontReady(fam); }).then(function () {
      targetFace();
      var b = banner(), s = safeArea(b.c, b.Wi, b.Hi), n = fc.getObjects().filter(function (o) { return o.ablKind === 'text'; }).length;
      var fs = clamp(Math.min(b.Hi * 0.22, b.Wi * 0.12), 1, 240);
      var t = look(new fabric.IText('Your text', { fontFamily: fam, fontSize: fs, fill: '#16161b', textAlign: 'center', originX: 'center', originY: 'center', left: b.Wi / 2, top: b.Hi / 2, paintFirst: 'stroke', strokeLineJoin: 'round', strokeWidth: 0, stroke: null, ablKind: 'text', ablStroke: 0 }));
      if (n) t.set({ top: clamp(b.Hi / 2 + [0, 1.25, -1.25][n % 3] * fs, s.y + fs / 2, s.y + s.h - fs / 2) });
      fitInside(t, s);
      place(t);
      track('text');
    }).catch(failed);
  }
  function addClip(c) {
    return ready().then(function () {
      targetFace();
      var b = banner(), s = safeArea(b.c, b.Wi, b.Hi);
      var p = look(new fabric.Path(c.d, { fill: clipColor, fillRule: 'evenodd', stroke: null, strokeWidth: 0, originX: 'center', originY: 'center', ablKind: 'clipart', ablLabel: c.name + ' clipart' }));
      p.scale(Math.min(s.w, s.h) * 0.45 / Math.max(p.width, p.height));
      p.set({ left: b.Wi / 2, top: b.Hi / 2 });
      place(p);
      track('clipart');
    }).catch(failed);
  }
  function failed() { toast('The design tools could not load. Please refresh the page and try again.', 7000); }
  function track(kind) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'ardor_banner_layer_added', layer: kind }); } catch (e) {} }

  // ---------- changes, history ----------
  function scheduleRender(now) {
    clearTimeout(renderT);
    renderT = setTimeout(function () { renderT = 0; try { API.renderArtOnly(); } catch (e) {} }, now ? 0 : 60);
  }
  function changed(record) {
    if (quiet || !fc) return;
    L[cur] = fc.getObjects().slice();
    rebase(L[cur], size.Wi, size.Hi);
    scheduleRender();
    if (record) pushHistory();
    syncPointer(); syncEmpty(); syncHist();
  }
  function ser(f) { return objectsFor(f).map(function (o) { return o.toObject(PROPS); }); }
  function snapshot() { return JSON.stringify({ W: size.Wi, H: size.Hi, f: ser('front'), b: ser('back') }); }
  function pushHistory() {
    clearTimeout(hist.t);
    hist.t = setTimeout(function () {
      var s = snapshot();
      if (hist.list[hist.i] === s) return;
      hist.list = hist.list.slice(0, hist.i + 1); hist.list.push(s);
      if (hist.list.length > 40) hist.list.shift();
      hist.i = hist.list.length - 1; syncHist();
    }, 200);
  }
  function enliven(arr) { return new Promise(function (res) { if (!arr.length) { res([]); return; } fabric.util.enlivenObjects(arr, function (objs) { res(objs.map(look)); }); }); }
  function restore(i) {
    if (!fc || i < 0 || i >= hist.list.length) return;
    hist.i = i;
    var snap = JSON.parse(hist.list[i]);
    Promise.all([enliven(snap.f), enliven(snap.b)]).then(function (r) {
      quiet = true;
      fc.discardActiveObject();
      var now = fc.getObjects().slice(); if (now.length) fc.remove.apply(fc, now);
      L.front = r[0]; L.back = r[1];
      [r[0], r[1]].forEach(function (objs) { rebase(objs, snap.W || size.Wi, snap.H || size.Hi); fitTo(objs, size.Wi, size.Hi); });
      L[cur].forEach(function (o) { fc.add(o); });
      quiet = false;
      [L.front, L.back].forEach(function (objs) { objs.forEach(function (o) { if (o.ablKind === 'cover') o.set({ selectable: false, evented: false }); }); });
      if (ai) { // undo / redo can bring the exact logo (and its patch) back or take them away
        ai.logoObj = L.front.filter(function (o) { return o.ablLogo; })[0] || null;
        ai.coverObj = L.front.filter(function (o) { return o.ablKind === 'cover'; })[0] || null;
        syncLogoBtn();
      }
      sync(); changed(false); syncProps();
    });
  }
  function undo() { clearTimeout(hist.t); restore(hist.i - 1); }
  function redo() { restore(hist.i + 1); }
  function syncHist() {
    if (!ui.hist) return;
    var show = !!fc && hist.list.length > 1 && editable() && (!ui.app || ui.app.getAttribute('data-mode') !== '3d');
    ui.hist.hidden = !show;
    ui.undo.disabled = hist.i <= 0; ui.redo.disabled = hist.i >= hist.list.length - 1;
    var mode = ui.app && $('.abx-mode', ui.app);
    if (show && mode) ui.hist.style.left = (mode.offsetLeft + mode.offsetWidth + 8) + 'px';
  }
  function removeActive() {
    var o = fc && fc.getActiveObject(); if (!o) return;
    fc.remove(o); fc.discardActiveObject(); fc.requestRenderAll();
  }

  // ---------- object bar and properties ----------
  function kindOf(o) { return o ? (o.ablKind || (o.type === 'i-text' || o.type === 'textbox' ? 'text' : o.type === 'image' ? 'image' : 'clipart')) : ''; }
  function posObjbar() {
    var bar = ui.objbar; if (!bar) return;
    var o = fc && fc.getActiveObject();
    if (!o || fc._currentTransform || !editable() || (ui.app && ui.app.getAttribute('data-mode') === '3d')) { bar.hidden = true; return; }
    var r = o.getBoundingRect();
    bar.hidden = false;
    var fw = ui.frame.clientWidth, bw = bar.offsetWidth || 300, bh = bar.offsetHeight || 46;
    var x = r.left + r.width / 2, y = r.top - 14;
    if (y - bh < 6) y = Math.min(ui.frame.clientHeight - 6, r.top + r.height + 14 + bh);
    bar.style.left = clamp(x, bw / 2 + 6, Math.max(bw / 2 + 6, fw - bw / 2 - 6)) + 'px';
    bar.style.top = y + 'px';
  }
  function syncProps() {
    if (!ui.props) return;
    var o = fc && fc.getActiveObject(), k = o && o.type !== 'activeSelection' && editable() ? kindOf(o) : '';
    ui.props.hidden = !k;
    posObjbar();
    if (!k) return;
    $$('[data-abl-p]', ui.props).forEach(function (g) { g.hidden = g.getAttribute('data-abl-p') !== k; });
    ui.pTitle.textContent = k === 'text' ? 'Text' : (k === 'image' ? (o.ablLogo ? 'Your logo' : 'Image') : 'Clipart');
    if (k === 'text') {
      if (document.activeElement !== ui.pText) ui.pText.value = o.text;
      ui.pFill.value = hex(o.fill); ui.pFillLbl.textContent = hex(o.fill).toUpperCase();
      if (!$('option[value="' + String(o.fontFamily).replace(/"/g, '') + '"]', ui.pFont)) { var op = el('option'); op.value = o.fontFamily; op.textContent = o.fontFamily; ui.pFont.appendChild(op); }
      ui.pFont.value = o.fontFamily;
      $$('[data-abl-align]', ui.props).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abl-align') === o.textAlign ? 'true' : 'false'); });
      ui.pStroke.value = String(o.ablStroke || 0);
      if (o.stroke) ui.pStrokeColor.value = hex(o.stroke);
    } else if (k === 'clipart') {
      ui.pClip.value = hex(o.fill); ui.pClipLbl.textContent = hex(o.fill).toUpperCase();
    }
  }
  function activeText() { var o = fc && fc.getActiveObject(); return o && kindOf(o) === 'text' ? o : null; }
  function setStroke(t) { var w = t.ablStroke || 0; t.set({ strokeWidth: w ? t.fontSize * w * 0.012 : 0, stroke: w ? ui.pStrokeColor.value : null }); }
  function objAction(act) {
    var o = fc && fc.getActiveObject(); if (!o) return;
    if (act === 'delete') { removeActive(); return; }
    if (act === 'duplicate') {
      o.clone(function (cl) {
        var d = Math.max(0.5, size.Hi * 0.04);
        look(cl); cl.set({ left: o.left + d, top: o.top + d, ablLogo: false });
        fc.add(cl); fc.setActiveObject(cl); cl.setCoords(); changed(true); syncProps();
      }, PROPS);
      return;
    }
    if (act === 'flipx') o.set('flipX', !o.flipX);
    if (act === 'flipy') o.set('flipY', !o.flipY);
    if (act === 'forward') fc.bringForward(o);
    if (act === 'backward') fc.sendBackwards(o);
    o.setCoords(); fc.requestRenderAll(); changed(true);
  }

  function bindCanvas() {
    var up = fc.upperCanvasEl;
    // nothing under the pointer: let the customer drag the artwork below, like before
    up.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      var t = null; try { t = fc.findTarget(e, false); } catch (er) {}
      if (t) return;
      e.preventDefault();
      if (fc.getActiveObject()) { if (fc.getActiveObject().isEditing) fc.getActiveObject().exitEditing(); fc.discardActiveObject(); fc.requestRenderAll(); }
      var lr = ui.lc.getBoundingClientRect();
      if (e.clientX < lr.left || e.clientX > lr.right || e.clientY < lr.top || e.clientY > lr.bottom) return;
      var ev = null;
      try { ev = new PointerEvent('pointerdown', { bubbles: true, cancelable: true, composed: true, clientX: e.clientX, clientY: e.clientY, screenX: e.screenX, screenY: e.screenY, pointerId: e.pointerId, pointerType: e.pointerType, isPrimary: e.isPrimary, button: e.button, buttons: e.buttons, width: e.width, height: e.height, pressure: e.pressure }); } catch (er) {}
      if (ev) ui.lc.dispatchEvent(ev);
    }, true);
    up.addEventListener('pointermove', function (e) {
      var lr = ui.lc.getBoundingClientRect(), a = API.getArt(cur);
      fc.defaultCursor = a && a.img && editable() && e.clientX >= lr.left && e.clientX <= lr.right && e.clientY >= lr.top && e.clientY <= lr.bottom ? 'move' : 'default';
    }, true);
    fc.on('object:added', function () { if (!quiet) changed(false); });
    fc.on('object:removed', function (e) {
      if (quiet) return;
      if (ai && e.target === ai.logoObj) { ai.logoObj = null; if (ai.coverObj) { var co = ai.coverObj; ai.coverObj = null; fc.remove(co); } syncLogoBtn(); }
      changed(true); syncProps();
    });
    fc.on('object:modified', function () { changed(true); posObjbar(); });
    ['object:moving', 'object:scaling', 'object:rotating'].forEach(function (n) { fc.on(n, function () { scheduleRender(); }); });
    fc.on('text:changed', function () { var t = activeText(); if (t && t.ablStroke) setStroke(t); syncProps(); scheduleRender(); });
    fc.on('text:editing:exited', function () { changed(true); });
    fc.on('selection:created', function () { syncProps(); var pb = ui.props && ui.props.parentNode; if (pb && phoneLayout() && pb.scrollTop > 0) pb.scrollTop = 0; });
    fc.on('selection:updated', syncProps);
    fc.on('selection:cleared', syncProps);
    fc.on('after:render', posObjbar);
  }

  // ---------- UI: rail tools, drawers, properties, object bar ----------
  function toolBtn(name, icon, label) {
    var b = el('button', 'abx-tool abl-tool', icon + '<span>' + label + '</span>');
    b.type = 'button'; b.setAttribute('data-abl-tool', name); b.setAttribute('aria-expanded', 'false');
    return b;
  }
  function ideaHref() { var c = API.cfg(); return IDEA_PAGE + '?w=' + nice(c.W) + '&h=' + nice(c.H); }
  function syncIdea() { var h = ideaHref(); $$('[data-abl-idea]', ui.root).forEach(function (a) { if (a.getAttribute('href') !== h) a.setAttribute('href', h); }); }
  function buildUi() {
    var app = ui.app, root = ui.root;
    ui.stage = app ? $('.abx-stage', app) : null;
    // rail: Text, Clipart, Ideas (after the logo, if the rail has one)
    var rail = app ? $('.abx-rail', app) : null;
    var tools = [toolBtn('text', '<span class="abl-tool-ic" aria-hidden="true">T<small>T</small></span>', 'Text'), toolBtn('clipart', '<span class="abl-tool-ic" aria-hidden="true">' + IC.clip + '</span>', 'Clipart')];
    var idea = el('a', 'abx-tool abl-tool abl-tool--idea', '<span class="abl-tool-ic" aria-hidden="true">' + IC.spark + '</span><span>Ideas</span>');
    idea.setAttribute('data-abl-idea', ''); idea.href = IDEA_PAGE;
    tools.push(idea);
    if (rail) {
      var logo = $(':scope > a[class*="logo"], :scope > [class*="rail-logo"], :scope > [data-abx-logo]', rail);
      var ref = logo ? logo.nextSibling : rail.firstChild;
      tools.forEach(function (t) { rail.insertBefore(t, ref); });
      rail.addEventListener('click', function (e) { if (e.target.closest('[data-abx-fly]')) closeDrawer(); }, true);
    } else {
      var mini = el('div', 'abl-minirail'); tools.forEach(function (t) { mini.appendChild(t); });
      var layout = $('[data-abb-layout]', root); if (layout) layout.parentNode.insertBefore(mini, layout);
    }
    root.addEventListener('click', function (e) { var b = e.target.closest('[data-abl-tool]'); if (b) openDrawer(b.getAttribute('data-abl-tool')); });

    // drawers (sticker builder style)
    var d = el('aside', 'abl-drawer' + (app ? '' : ' abl-drawer--fixed'));
    d.setAttribute('aria-hidden', 'true'); d.setAttribute('aria-label', 'Text and clipart');
    d.innerHTML =
      '<div class="abl-drawer__panel" data-abl-panel="text">' +
        '<div class="abl-drawer__head"><h2>Add text</h2><button type="button" class="abl-x" data-abl-close aria-label="Close">' + IC.x + '</button></div>' +
        '<div class="abl-drawer__body"><p class="abl-help">Tap a font to add text to your banner. Double-tap the text on your banner, or use the text box in the options, to change the words.</p><div class="abl-fonts" data-abl-fonts></div></div>' +
      '</div>' +
      '<div class="abl-drawer__panel" data-abl-panel="clipart" hidden>' +
        '<div class="abl-drawer__head"><h2>Clipart</h2><button type="button" class="abl-x" data-abl-close aria-label="Close">' + IC.x + '</button></div>' +
        '<div class="abl-drawer__body"><div class="abl-cliptools"><input class="abl-input" type="search" placeholder="Search clipart" aria-label="Search clipart" data-abl-clip-search>' +
        '<label class="abl-color abl-color--swatch" title="Clipart color"><input type="color" value="' + clipColor + '" aria-label="Clipart color" data-abl-clip-default></label></div>' +
        '<div class="abl-clips" data-abl-clips></div></div>' +
      '</div>';
    (app || root).appendChild(d);
    ui.drawer = d;
    var fonts = $('[data-abl-fonts]', d);
    FONTS.forEach(function (f) {
      var b = el('button', 'abl-font'); b.type = 'button'; b.textContent = f[1];
      b.style.fontFamily = '\'' + f[0] + '\', sans-serif';
      b.addEventListener('click', function () { addText(f[0]); });
      fonts.appendChild(b);
    });
    ui.clips = $('[data-abl-clips]', d);
    renderClips('');
    $('[data-abl-clip-search]', d).addEventListener('input', function (e) { renderClips(e.target.value.trim().toLowerCase()); });
    $('[data-abl-clip-default]', d).addEventListener('input', function (e) { clipColor = e.target.value; d.style.setProperty('--abl-clip', clipColor); });
    $$('[data-abl-close]', d).forEach(function (b) { b.addEventListener('click', closeDrawer); });

    // properties of the selected layer, at the top of the options panel
    var p = el('section', 'abl-props');
    p.hidden = true; p.setAttribute('aria-label', 'Selected text or clipart');
    p.innerHTML =
      '<div class="abl-props__head"><h3 data-abl-title>Text</h3><button type="button" class="abl-done" data-abl-deselect>Done</button></div>' +
      '<div data-abl-p="text">' +
        '<textarea class="abl-input abl-textarea" rows="2" aria-label="Text" data-abl-text></textarea>' +
        '<div class="abl-two"><div><span class="abl-label">Color</span><label class="abl-color"><input type="color" value="#16161b" aria-label="Text color" data-abl-fill><span data-abl-fill-lbl>#16161B</span></label></div>' +
        '<div><span class="abl-label">Font</span><select class="abl-input" aria-label="Font" data-abl-font></select></div></div>' +
        '<div class="abl-two abl-two--even"><div><span class="abl-label">Align</span><div class="abl-align">' +
          '<button type="button" data-abl-align="left" aria-label="Align left">' + IC.left + '</button>' +
          '<button type="button" data-abl-align="center" aria-label="Align center">' + IC.center + '</button>' +
          '<button type="button" data-abl-align="right" aria-label="Align right">' + IC.right + '</button></div></div>' +
        '<div><span class="abl-label">Outline</span><div class="abl-slider"><input type="range" min="0" max="12" step="1" value="0" aria-label="Outline width" data-abl-stroke><input type="color" value="#ffffff" aria-label="Outline color" data-abl-stroke-color></div></div></div>' +
      '</div>' +
      '<div data-abl-p="clipart" hidden><span class="abl-label">Clipart color</span><label class="abl-color"><input type="color" value="#dc1f2a" aria-label="Clipart color" data-abl-clip><span data-abl-clip-lbl>#DC1F2A</span></label></div>' +
      '<div data-abl-p="image" hidden><p class="abl-help">Drag it to move it. Drag a corner to resize it. We print this file exactly as you uploaded it.</p><button type="button" class="abl-done abl-done--danger" data-abl-remove>Remove</button></div>';
    var body = app ? $('[data-abx-body]', app) : null;
    if (body) body.insertBefore(p, body.firstChild);
    else { var ctl = $('[data-abb-layout]', root); if (ctl) ctl.appendChild(p); }
    ui.props = p; ui.pTitle = $('[data-abl-title]', p);
    ui.pText = $('[data-abl-text]', p); ui.pFill = $('[data-abl-fill]', p); ui.pFillLbl = $('[data-abl-fill-lbl]', p);
    ui.pFont = $('[data-abl-font]', p); ui.pStroke = $('[data-abl-stroke]', p); ui.pStrokeColor = $('[data-abl-stroke-color]', p);
    ui.pClip = $('[data-abl-clip]', p); ui.pClipLbl = $('[data-abl-clip-lbl]', p);
    FONTS.forEach(function (f) { var o = el('option'); o.value = f[0]; o.textContent = f[1]; ui.pFont.appendChild(o); });
    bindProps(p);

    // object bar (flip, order, duplicate, delete)
    var ob = el('div', 'abl-objbar');
    ob.hidden = true; ob.setAttribute('role', 'toolbar'); ob.setAttribute('aria-label', 'Selected item');
    ob.innerHTML =
      '<button type="button" data-abl-act="flipx" title="Flip horizontal" aria-label="Flip horizontal">' + IC.flipx + '</button>' +
      '<button type="button" data-abl-act="flipy" title="Flip vertical" aria-label="Flip vertical">' + IC.flipy + '</button><i></i>' +
      '<button type="button" data-abl-act="forward" title="Bring forward" aria-label="Bring forward">' + IC.forward + '</button>' +
      '<button type="button" data-abl-act="backward" title="Send backward" aria-label="Send backward">' + IC.backward + '</button><i></i>' +
      '<button type="button" data-abl-act="duplicate" title="Duplicate" aria-label="Duplicate">' + IC.duplicate + '</button>' +
      '<button type="button" data-abl-act="delete" title="Delete" aria-label="Delete">' + IC.trash + '</button>';
    ob.addEventListener('click', function (e) { var b = e.target.closest('[data-abl-act]'); if (b) objAction(b.getAttribute('data-abl-act')); });
    ui.objbar = ob;

    // undo / redo, toast and the AI logo button live on the canvas area
    var host = ui.stage || (API.layoutCanvas() && API.layoutCanvas().parentNode) || root;
    ui.hist = el('div', 'abl-hist', '<button type="button" class="abl-chip" data-abl-undo title="Undo (Ctrl+Z)" aria-label="Undo">' + IC.undo + '</button><button type="button" class="abl-chip" data-abl-redo title="Redo (Ctrl+Shift+Z)" aria-label="Redo">' + IC.redo + '</button>');
    ui.hist.hidden = true; host.appendChild(ui.hist);
    ui.undo = $('[data-abl-undo]', ui.hist); ui.redo = $('[data-abl-redo]', ui.hist);
    ui.undo.addEventListener('click', undo); ui.redo.addEventListener('click', redo);
    ui.toast = el('div', 'abl-toast', '<span data-abl-toast-text></span><button type="button" class="abl-toast__act" data-abl-toast-act hidden></button><button type="button" class="abl-toast__x" aria-label="Dismiss" data-abl-toast-x>' + IC.x + '</button>');
    ui.toast.hidden = true; ui.toast.setAttribute('role', 'status'); ui.toast.setAttribute('aria-live', 'polite');
    host.appendChild(ui.toast);
    $('[data-abl-toast-x]', ui.toast).addEventListener('click', function () { ui.toast.hidden = true; });
    ui.logoBtn = el('button', 'abl-logo-btn', IC.logo + '<span data-abl-logo-lbl>Use my exact logo</span>');
    ui.logoBtn.type = 'button'; ui.logoBtn.hidden = true;
    ui.logoBtn.addEventListener('click', useLogo);
    var tbar = app && $('[data-abx-bar]', app); // first item of the 2D toolbar, so it never covers the canvas tools
    if (tbar) tbar.insertBefore(ui.logoBtn, tbar.firstChild); else host.appendChild(ui.logoBtn);

    // "No artwork? Describe your idea" on the empty canvas card and in the Artwork flyout
    var card = app && $('.abx-empty__card', app);
    if (card) {
      var a1 = el('a', 'abl-empty-idea', IC.spark + ' No artwork? <u>Describe your banner</u> and our AI designs it');
      a1.setAttribute('data-abl-idea', ''); a1.href = IDEA_PAGE; card.appendChild(a1);
    }
    var drop = $('[data-abb-drop]', root);
    if (drop) {
      var a2 = el('a', 'abl-idea-cta', '<span class="abl-idea-cta__ic" aria-hidden="true">' + IC.spark + '</span><span><b>Stuck? Describe your idea</b><small>We\'ll draw 4 banner designs for you, free.</small></span>');
      a2.setAttribute('data-abl-idea', ''); a2.href = IDEA_PAGE;
      drop.parentNode.insertBefore(a2, drop.nextSibling);
    }
    syncIdea();
  }
  function renderClips(q) {
    var box = ui.clips; box.textContent = '';
    var last = '';
    CLIPART.filter(function (c) { return !q || c.name.indexOf(q) >= 0 || c.cat.toLowerCase().indexOf(q) >= 0; }).forEach(function (c) {
      if (c.cat !== last) { box.appendChild(el('div', 'abl-clip-cat', c.cat)); last = c.cat; }
      var b = el('button', 'abl-clip', '<svg viewBox="0 0 100 100" aria-hidden="true"><path d="' + c.d + '" fill="currentColor" fill-rule="evenodd"/></svg>');
      b.type = 'button'; b.title = c.name; b.setAttribute('aria-label', 'Add ' + c.name);
      b.addEventListener('click', function () { addClip(c); });
      box.appendChild(b);
    });
    if (!box.children.length) box.appendChild(el('p', 'abl-help', 'No clipart matches that word.'));
  }
  function bindProps(p) {
    var t = function () { return activeText(); };
    ui.pText.addEventListener('input', function () { var o = t(); if (!o) return; o.set('text', ui.pText.value || ' '); if (o.ablStroke) setStroke(o); o.setCoords(); fc.requestRenderAll(); scheduleRender(); });
    ui.pText.addEventListener('change', function () { changed(true); });
    ui.pFill.addEventListener('input', function () { var o = t(); if (!o) return; o.set('fill', ui.pFill.value); ui.pFillLbl.textContent = ui.pFill.value.toUpperCase(); fc.requestRenderAll(); scheduleRender(); });
    ui.pFill.addEventListener('change', function () { changed(true); });
    ui.pFont.addEventListener('change', function () {
      var o = t(), fam = ui.pFont.value; if (!o) return;
      fontReady(fam).then(function () { o.set('fontFamily', fam); if (o.initDimensions) o.initDimensions(); o.setCoords(); fc.requestRenderAll(); changed(true); });
    });
    $$('[data-abl-align]', p).forEach(function (b) { b.addEventListener('click', function () { var o = t(); if (!o) return; o.set('textAlign', b.getAttribute('data-abl-align')); fc.requestRenderAll(); syncProps(); changed(true); }); });
    ui.pStroke.addEventListener('input', function () { var o = t(); if (!o) return; o.ablStroke = parseInt(ui.pStroke.value, 10) || 0; setStroke(o); o.setCoords(); fc.requestRenderAll(); scheduleRender(); });
    ui.pStroke.addEventListener('change', function () { changed(true); });
    ui.pStrokeColor.addEventListener('input', function () { var o = t(); if (!o || !o.ablStroke) return; o.set('stroke', ui.pStrokeColor.value); fc.requestRenderAll(); scheduleRender(); });
    ui.pStrokeColor.addEventListener('change', function () { changed(true); });
    ui.pClip.addEventListener('input', function () { var o = fc && fc.getActiveObject(); if (!o || kindOf(o) !== 'clipart') return; o.set('fill', ui.pClip.value); ui.pClipLbl.textContent = ui.pClip.value.toUpperCase(); fc.requestRenderAll(); scheduleRender(); });
    ui.pClip.addEventListener('change', function () { changed(true); });
    $('[data-abl-deselect]', p).addEventListener('click', function () { if (fc) { var o = fc.getActiveObject(); if (o && o.isEditing) o.exitEditing(); fc.discardActiveObject(); fc.requestRenderAll(); } });
    $('[data-abl-remove]', p).addEventListener('click', removeActive);
  }
  function openDrawer(name) {
    var isOpen = ui.drawer.classList.contains('is-open') && ui.drawerName === name;
    if (isOpen) { closeDrawer(); return; }
    if (ui.app) {
      var fly = $('[data-abx-flyout]', ui.app);
      if (fly && !fly.hidden) { var x = $('[data-abx-fly-close]', ui.app); if (x) x.click(); }
    }
    ui.drawerName = name;
    $$('[data-abl-panel]', ui.drawer).forEach(function (p) { p.hidden = p.getAttribute('data-abl-panel') !== name; });
    ui.drawer.classList.add('is-open'); ui.drawer.setAttribute('aria-hidden', 'false');
    $$('[data-abl-tool]', ui.root).forEach(function (b) { var on = b.getAttribute('data-abl-tool') === name; b.classList.toggle('is-on', on); b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    if (name === 'text') loadFonts();
    ready().catch(function () {});
  }
  function closeDrawer() {
    if (!ui.drawer) return;
    ui.drawer.classList.remove('is-open'); ui.drawer.setAttribute('aria-hidden', 'true');
    $$('[data-abl-tool]', ui.root).forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-expanded', 'false'); });
  }

  // the "drop your art" card hides while the banner has text or clipart
  function syncEmpty() {
    var empty = ui.app && $('[data-abx-empty]', ui.app); if (!empty) return;
    var any = has('front') || has('back');
    ui.app.classList.toggle('abl-has-layers', any);
    if (any && !empty.hidden) { empty.hidden = true; ui.hidEmpty = true; }
    else if (!any && ui.hidEmpty) {
      ui.hidEmpty = false;
      var fn = $('[data-abb-file-name]', ui.root), dz = $('[data-abb-design]', ui.root);
      if (!(fn && !fn.hidden) && !(dz && dz.checked) && API.editFace()) empty.hidden = false;
    }
  }

  // ---------- toast ----------
  function toast(msg, ms, action) {
    var t = ui.toast; if (!t) return;
    $('[data-abl-toast-text]', t).textContent = msg;
    var b = $('[data-abl-toast-act]', t);
    b.hidden = !action; b.textContent = action ? action.label : ''; b.onclick = action ? function () { t.hidden = true; action.run(); } : null;
    t.hidden = false;
    clearTimeout(toast.t);
    if (ms) toast.t = setTimeout(function () { t.hidden = true; }, ms);
  }

  // ---------- AI banner hand-off: ?ai=<id>&w=&h=[&logo=<id>&lb=x0,y0,x1,y1] ----------
  function parseBox(s) {
    var a = String(s || '').split(',').map(parseFloat);
    if (a.length !== 4 || !a.every(isFinite)) return null;
    var b = [clamp(Math.min(a[0], a[2]), 0, 1), clamp(Math.min(a[1], a[3]), 0, 1), clamp(Math.max(a[0], a[2]), 0, 1), clamp(Math.max(a[1], a[3]), 0, 1)];
    return b[2] - b[0] > 0.005 && b[3] - b[1] > 0.005 ? b : null;
  }
  function cleanUrl() {
    try {
      var u = new URL(window.location.href);
      ['ai', 'w', 'h', 'logo', 'lb', 'ends'].forEach(function (k) { u.searchParams.delete(k); });
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function fetchImage(url) {
    return fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); }).then(function (b) {
      return new Promise(function (res, rej) {
        var u = URL.createObjectURL(b), im = new Image();
        im.onload = function () { res({ blob: b, img: im, url: u, w: im.naturalWidth, h: im.naturalHeight }); };
        im.onerror = function () { rej(new Error('decode')); };
        im.src = u;
      });
    });
  }
  function sniff(b) {
    return b.slice(0, 12).arrayBuffer().then(function (ab) {
      var u = new Uint8Array(ab);
      if (u[0] === 0x89 && u[1] === 0x50) return ['image/png', '.png'];
      if (u[0] === 0x52 && u[1] === 0x49 && u[8] === 0x57) return ['image/webp', '.webp'];
      return ['image/jpeg', '.jpg'];
    }).catch(function () { return ['image/jpeg', '.jpg']; });
  }
  function handoff() {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    var id = String(q.get('ai') || '').toLowerCase();
    if (!/^[0-9a-f]{32}$/.test(id)) return;
    var w = parseFloat(q.get('w')), h = parseFloat(q.get('h')), logo = String(q.get('logo') || ''), smooth = q.get('ends') === 'smooth';
    ai = { id: id, logo: /^[0-9A-Za-z_-]{8,64}$/.test(logo) ? logo : '', lb: parseBox(q.get('lb')), ext: null, logoObj: null };
    if (w >= 1 && w <= 100 && h >= 1 && h <= 100) API.set({ w: nice(w), h: nice(h) });
    toast('Loading your AI banner design\u2026', 0);
    fetchImage(apiBase() + '/bimg/' + id).then(function (r) {
      var c = API.cfg(), B = c.W / c.H, A = r.w / r.h;
      var wide = (B > 3 || B < 1 / 3) && (B / A > 1.03 || A / B > 1.03);
      var made = wide ? extend(r.img, r.w, r.h, B, smooth) : sniff(r.blob).then(function (t) { return { blob: r.blob, type: t, ext: { cw: r.w, ch: r.h, ox: 0, oy: 0, iw: r.w, ih: r.h } }; });
      return made.then(function (x) {
        var file = new File([x.blob], 'ardor-ai-banner-' + id.slice(0, 8) + x.type[1], { type: x.type[0] });
        ai.ext = x.ext; ai.file = file; ai.aiImg = r.img;
        API.loadFile(file, 'front');
        return waitFor(function () { var a = API.getArt('front'); return a && a.file === file && a.img ? a : null; }, 20000);
      });
    }).then(function (a) {
      if (a.mode !== 'fill') { a.mode = 'fill'; API.render(); }
      cleanUrl();
      if (ai.logo) { syncLogoBtn(); toast('Your AI design is on your banner. Tap "Use my exact logo" to put your original logo file over the AI\'s version.', 9000); }
      else toast('Your AI design is on your banner. Add text or clipart, or drag it to move it.', 7000);
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'ardor_banner_ai_design_loaded' }); } catch (e) {}
    }).catch(function () {
      toast('We couldn\'t load your AI design. Go back to the AI banner page and tap "Use this design" again.', 10000);
    });
  }
  // banners wider than 3:1 (or taller than 1:3): AI image centered, the sides filled by stretching its edge pixels,
  // sharp at the seam and blurred further out. smooth = true (the customer picked Smooth ends on the AI page, &ends=smooth)
  // fills the sides with a soft blend of the edge colors instead and feathers the seam into the design's outer 5%.
  function extend(img, iw0, ih0, B, smooth) {
    var wide = B > 1, cw, ch;
    if (wide) { ch = ih0; cw = ih0 * B; } else { cw = iw0; ch = iw0 / B; }
    var s = Math.min(1, 16384 / cw, 16384 / ch, Math.sqrt((isPhone() ? 16e6 : 40e6) / (cw * ch)));
    cw = Math.max(1, Math.round(cw * s)); ch = Math.max(1, Math.round(ch * s));
    var iw = wide ? Math.round(iw0 * ch / ih0) : cw, ih = wide ? ch : Math.round(ih0 * cw / iw0);
    var ox = wide ? Math.round((cw - iw) / 2) : 0, oy = wide ? 0 : Math.round((ch - ih) / 2);
    var cv = mkCanvas(cw, ch), x = cv.getContext('2d');
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    var A = wide ? ['l', 0, 0, ox, ch, 'r', ox + iw, 0, cw - ox - iw, ch] : ['t', 0, 0, cw, oy, 'b', 0, oy + ih, cw, ch - oy - ih];
    for (var q = 0; q < 10; q += 5) (smooth ? soften : side)(x, img, iw0, ih0, A[q], A[q + 1], A[q + 2], A[q + 3], A[q + 4]);
    x.drawImage(img, ox, oy, iw, ih);
    if (smooth) {
      var f = Math.max(2, Math.round((wide ? iw : ih) * 0.05));
      if (wide) { soften(x, img, iw0, ih0, 'l', ox, 0, f, ch, 1); soften(x, img, iw0, ih0, 'r', ox + iw - f, 0, f, ch, 1); }
      else { soften(x, img, iw0, ih0, 't', 0, oy, cw, f, 1); soften(x, img, iw0, ih0, 'b', 0, oy + ih - f, cw, f, 1); }
    }
    return toBlob(cv, 'image/jpeg', 0.92).then(function (b) {
      cv.width = cv.height = 1;
      if (!b) throw new Error('extend');
      return { blob: b, type: ['image/jpeg', '.jpg'], ext: { cw: cw, ch: ch, ox: ox, oy: oy, iw: iw, ih: ih } };
    });
  }
  // soft fill for one side: the outer 6% of the design averaged into 6 steps along the edge, then
  // stretched smoothly over the side. feather = 1 draws it over the design's own edge, fading out inward.
  function soften(x, img, iw0, ih0, where, dx, dy, dw, dh, feather) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', band = Math.max(1, Math.round((horiz ? iw0 : ih0) * 0.06));
    var mid = horiz ? mkCanvas(1, 64) : mkCanvas(64, 1), mx = mid.getContext('2d');
    mx.imageSmoothingEnabled = true; mx.imageSmoothingQuality = 'high';
    if (where === 'l') mx.drawImage(img, 0, 0, band, ih0, 0, 0, 1, 64);
    if (where === 'r') mx.drawImage(img, iw0 - band, 0, band, ih0, 0, 0, 1, 64);
    if (where === 't') mx.drawImage(img, 0, 0, iw0, band, 0, 0, 64, 1);
    if (where === 'b') mx.drawImage(img, 0, ih0 - band, iw0, band, 0, 0, 64, 1);
    var small = horiz ? mkCanvas(1, 6) : mkCanvas(6, 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(mid, 0, 0, small.width, small.height);
    var soft = mkCanvas(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    if (feather) {
      var g = where === 'l' ? so.createLinearGradient(0, 0, dw, 0) : where === 'r' ? so.createLinearGradient(dw, 0, 0, 0)
        : where === 't' ? so.createLinearGradient(0, 0, 0, dh) : so.createLinearGradient(0, dh, 0, 0);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    }
    x.drawImage(soft, dx, dy);
  }
  function side(x, img, iw0, ih0, where, dx, dy, dw, dh) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', n = Math.max(1, Math.min(4, horiz ? iw0 : ih0));
    var line = horiz ? mkCanvas(1, dh) : mkCanvas(dw, 1), lx = line.getContext('2d');
    lx.imageSmoothingEnabled = true; lx.imageSmoothingQuality = 'high';
    if (where === 'l') lx.drawImage(img, 0, 0, n, ih0, 0, 0, 1, dh);
    if (where === 'r') lx.drawImage(img, iw0 - n, 0, n, ih0, 0, 0, 1, dh);
    if (where === 't') lx.drawImage(img, 0, 0, iw0, n, 0, 0, dw, 1);
    if (where === 'b') lx.drawImage(img, 0, ih0 - n, iw0, n, 0, 0, dw, 1);
    var sharp = mkCanvas(dw, dh), sx = sharp.getContext('2d');
    sx.imageSmoothingEnabled = false;
    sx.drawImage(line, 0, 0, dw, dh);
    var len = horiz ? dh : dw, k = Math.max(2, Math.round(len / 40));
    var small = horiz ? mkCanvas(1, Math.max(2, Math.round(dh / k))) : mkCanvas(Math.max(2, Math.round(dw / k)), 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(line, 0, 0, small.width, small.height);
    var soft = mkCanvas(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    var fade = Math.max(1, Math.min(horiz ? dw : dh, len * 0.3)), g;
    if (where === 'l') g = so.createLinearGradient(dw, 0, dw - fade, 0);
    else if (where === 'r') g = so.createLinearGradient(0, 0, fade, 0);
    else if (where === 't') g = so.createLinearGradient(0, dh, 0, dh - fade);
    else g = so.createLinearGradient(0, 0, 0, fade);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,1)');
    so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    sx.drawImage(soft, 0, 0);
    x.drawImage(sharp, dx, dy);
  }
  function syncLogoBtn() {
    var b = ui.logoBtn; if (!b) return;
    b.hidden = !(ai && ai.logo);
    if (b.hidden) return;
    var on = !!(ai.logoObj && fc && objectsFor('front').indexOf(ai.logoObj) >= 0);
    if (!on) ai.logoObj = null;
    $('[data-abl-logo-lbl]', b).textContent = on ? 'Remove my exact logo' : 'Use my exact logo';
    b.classList.toggle('is-on', on);
  }
  // a box normalized to the AI image -> banner inches (where that part of the AI design sits on the banner now)
  function aiBox(nb) {
    var g = API.artGeom('front'), e = ai.ext;
    if (!g || !e || !nb) return null;
    var X = function (u) { return g.x + (e.ox + u * e.iw) / e.cw * g.w; }, Y = function (v) { return g.y + (e.oy + v * e.ih) / e.ch * g.h; };
    return { x: X(nb[0]), y: Y(nb[1]), w: X(nb[2]) - X(nb[0]), h: Y(nb[3]) - Y(nb[1]) };
  }
  function logoBox(ar) {
    var b = banner(), s = safeArea(b.c, b.Wi, b.Hi), bx = aiBox(ai.lb);
    if (!bx) bx = { x: s.x + s.w * 0.3, y: s.y + s.h * 0.25, w: s.w * 0.4, h: s.h * 0.5 };
    var w = bx.w, h = w / ar; if (h > bx.h) { h = bx.h; w = h * ar; }
    if (w > s.w) { w = s.w; h = w / ar; } if (h > s.h) { h = s.h; w = h * ar; }
    return { cx: clamp(bx.x + bx.w / 2, s.x + w / 2, s.x + s.w - w / 2), cy: clamp(bx.y + bx.h / 2, s.y + h / 2, s.y + s.h - h / 2), w: w, h: h };
  }
  // When the AI's logo sits on one even background color, a patch of that color goes over the AI's logo before the
  // original file is placed, so the AI's slightly different drawing doesn't show around it. The color is read from a
  // thin ring just outside the logo box; if that ring isn't one even color (text, photo, gradient), no patch is used.
  // No patch either when much of the logo file is close to that color (for example a black logo on a black banner,
  // where the AI redrew it in white): there the AI's version is what keeps the logo readable.
  function coverFor(lb, logoImg) {
    var img = ai && ai.aiImg; if (!img || !lb) return null;
    var aw = img.naturalWidth || img.width, ah = img.naturalHeight || img.height; if (!aw || !ah) return null;
    var W = 240, H = Math.max(8, Math.round(W * ah / aw)), c = mkCanvas(W, H), x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data, bw = lb[2] - lb[0], bh = lb[3] - lb[1];
    var gx = Math.max(bw * 0.03, 2 / W), gy = Math.max(bh * 0.03, 2 / H), rx = Math.max(bw * 0.08, 5 / W), ry = Math.max(bh * 0.08, 5 / H);
    var inn = [lb[0] - gx, lb[1] - gy, lb[2] + gx, lb[3] + gy], out = [lb[0] - rx, lb[1] - ry, lb[2] + rx, lb[3] + ry];
    var R = [], G = [], B = [], px, py;
    for (py = Math.max(0, Math.floor(out[1] * H)); py < Math.min(H, Math.ceil(out[3] * H)); py++) {
      for (px = Math.max(0, Math.floor(out[0] * W)); px < Math.min(W, Math.ceil(out[2] * W)); px++) {
        var u = (px + 0.5) / W, v = (py + 0.5) / H;
        if (u > inn[0] && u < inn[2] && v > inn[1] && v < inn[3]) continue;
        var i = (py * W + px) * 4; R.push(d[i]); G.push(d[i + 1]); B.push(d[i + 2]);
      }
    }
    if (R.length < 40) return null;
    var med = function (a) { var b2 = a.slice().sort(function (p, q) { return p - q; }); return b2[b2.length >> 1]; };
    var mr = med(R), mg = med(G), mb = med(B), near = 0;
    for (var k = 0; k < R.length; k++) if (Math.max(Math.abs(R[k] - mr), Math.abs(G[k] - mg), Math.abs(B[k] - mb)) <= 36) near++;
    if (near / R.length < 0.85) return null;
    if (logoImg) {
      var lw = logoImg.naturalWidth || logoImg.width, lh = logoImg.naturalHeight || logoImg.height;
      if (lw && lh) {
        var LW = Math.min(200, lw), LH = Math.max(1, Math.round(LW * lh / lw)), lc = mkCanvas(LW, LH), lx = lc.getContext('2d', { willReadFrequently: true });
        lx.drawImage(logoImg, 0, 0, LW, LH);
        var ld = lx.getImageData(0, 0, LW, LH).data, op = 0, same = 0;
        for (var j = 0; j < ld.length; j += 4) {
          if (ld[j + 3] < 128) continue;
          op++;
          if (Math.max(Math.abs(ld[j] - mr), Math.abs(ld[j + 1] - mg), Math.abs(ld[j + 2] - mb)) <= 60) same++;
        }
        if (!op || same / op > 0.2) return null;
      }
    }
    return { color: 'rgb(' + mr + ',' + mg + ',' + mb + ')', box: [Math.max(0, inn[0]), Math.max(0, inn[1]), Math.min(1, inn[2]), Math.min(1, inn[3])] };
  }
  // Finds the customer's logo inside the AI design so the original file lands right on top of the AI's version.
  // Matches edge maps (normalized cross-correlation of gradient magnitude), which ignores recoloring such as dark
  // logo text the AI turned white on a dark background. The AI sometimes draws the logo a little wider or narrower
  // than the file, so a coarse search (image about 40,000 px) tries several widths at the file's shape and, when that
  // match is weak, at wider and narrower shapes too; a 1-pixel fine pass then refines the best one. Tiny templates
  // are skipped (they match noise). Returns a box normalized to the AI image [x0,y0,x1,y1], or null when nothing matches
  // well (we then use the AI check's box).
  function findLogo(aiImg, logoImg) {
    var aw = aiImg.naturalWidth || aiImg.width, ah = aiImg.naturalHeight || aiImg.height;
    var lw0 = logoImg.naturalWidth || logoImg.width, lh0 = logoImg.naturalHeight || logoImg.height;
    if (!aw || !ah || !lw0 || !lh0) return null;
    function lum(img, w, h, bg) {
      var c = mkCanvas(w, h), x = c.getContext('2d', { willReadFrequently: true });
      if (bg) { x.fillStyle = bg; x.fillRect(0, 0, w, h); }
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high'; x.drawImage(img, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data, g = new Float32Array(w * h);
      for (var i = 0; i < w * h; i++) g[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];
      return g;
    }
    function edges(g, w, h) {
      var e = new Float32Array(w * h);
      for (var y = 1; y < h - 1; y++) for (var x = 1; x < w - 1; x++) {
        var i = y * w + x;
        var gx = g[i + 1] - g[i - 1] + 0.5 * (g[i - w + 1] - g[i - w - 1] + g[i + w + 1] - g[i + w - 1]);
        var gy = g[i + w] - g[i - w] + 0.5 * (g[i + w - 1] - g[i - w - 1] + g[i + w + 1] - g[i - w + 1]);
        e[i] = Math.sqrt(gx * gx + gy * gy);
      }
      return e;
    }
    function prep(W) {
      var H = Math.max(16, Math.round(W * ah / aw)), W1 = W + 1, EA = edges(lum(aiImg, W, H), W, H);
      var S = new Float64Array(W1 * (H + 1)), S2 = new Float64Array(W1 * (H + 1));
      for (var y = 0; y < H; y++) {
        var r = 0, r2 = 0;
        for (var x = 0; x < W; x++) { var v = EA[y * W + x]; r += v; r2 += v * v; S[(y + 1) * W1 + x + 1] = S[y * W1 + x + 1] + r; S2[(y + 1) * W1 + x + 1] = S2[y * W1 + x + 1] + r2; }
      }
      return { W: W, H: H, W1: W1, EA: EA, S: S, S2: S2 };
    }
    function box(G, T, x, y, w, h) { var W1 = G.W1; return T[(y + h) * W1 + x + w] - T[y * W1 + x + w] - T[(y + h) * W1 + x] + T[y * W1 + x]; }
    // f = logo width as a share of the image width, a = how much wider the AI drew it than the file (1 = same shape)
    function tmpl(G, f, a) {
      var lw = Math.round(G.W * f), lh = Math.round(lw * lh0 / lw0 / a);
      if (lw < 24 || lh < 10 || lw * lh < 600 || lw >= G.W || lh >= G.H) return null;
      var ET = edges(lum(logoImg, lw, lh, '#808080'), lw, lh), n = lw * lh, m = 0, v = 0, i;
      for (i = 0; i < n; i++) m += ET[i];
      m /= n;
      var Z = new Float32Array(n), idx = [];
      for (i = 0; i < n; i++) { Z[i] = ET[i] - m; v += Z[i] * Z[i]; if (Math.abs(Z[i]) > 1e-3) idx.push(i); }
      return v > 0 ? { lw: lw, lh: lh, n: n, Z: Z, v: v, idx: idx, f: f, a: a } : null;
    }
    function score(G, T, x, y, stride) {
      var s = box(G, G.S, x, y, T.lw, T.lh), s2 = box(G, G.S2, x, y, T.lw, T.lh), va = s2 - s * s / T.n;
      if (va < 1) return 0;
      var sl = 0, idx = T.idx, Z = T.Z, lw = T.lw, EA = G.EA, W = G.W;
      for (var k = 0; k < idx.length; k += stride) { var i = idx[k], ty = (i / lw) | 0; sl += Z[i] * EA[(y + ty) * W + x + i - ty * lw]; }
      return sl * stride / Math.sqrt(va * T.v);
    }
    // about 40,000 pixels for the search (240 px wide for a 2:1 banner, about 160 px for a tall design)
    var CW = Math.max(150, Math.min(240, Math.round(Math.sqrt(40000 * aw / ah)))), G1 = prep(CW), best = { sc: 0 };
    function coarse(a) {
      for (var f = 0.1; f <= 0.98; f *= 1.07) {
        var T = tmpl(G1, f, a); if (!T) continue;
        for (var y = 0; y <= G1.H - T.lh; y += 2) for (var x = 0; x <= G1.W - T.lw; x += 2) { var sc = score(G1, T, x, y, 2); if (sc > best.sc) best = { sc: sc, x: x, y: y, T: T }; }
      }
    }
    coarse(1);
    if (best.sc < 0.65) [0.9, 1.08, 1.18, 1.32].forEach(coarse);
    if (!best.T) return null;
    var fine = { sc: 0 };
    [best.T.f / 1.03, best.T.f, best.T.f * 1.03].forEach(function (ff) {
      [best.T.a / 1.08, best.T.a / 1.04, best.T.a, best.T.a * 1.04, best.T.a * 1.08].forEach(function (aa) {
        var T2 = tmpl(G1, ff, aa); if (!T2) return;
        for (var yy = Math.max(0, best.y - 3); yy <= Math.min(G1.H - T2.lh, best.y + 3); yy++) for (var xx = Math.max(0, best.x - 3); xx <= Math.min(G1.W - T2.lw, best.x + 3); xx++) {
          var s3 = score(G1, T2, xx, yy, 1); if (s3 > fine.sc) fine = { sc: s3, x: xx, y: yy, T: T2 };
        }
      });
    });
    if (!fine.T || fine.sc < 0.55) return null;
    return [fine.x / G1.W, fine.y / G1.H, (fine.x + fine.T.lw) / G1.W, (fine.y + fine.T.lh) / G1.H];
  }
  function removeLogo() {
    if (ai && fc) {
      if (ai.logoObj) { fc.remove(ai.logoObj); ai.logoObj = null; }
      if (ai.coverObj) { fc.remove(ai.coverObj); ai.coverObj = null; }
      fc.requestRenderAll();
    }
    syncLogoBtn();
  }

  function useLogo() {
    if (!ai || !ai.logo || ui.logoBtn.disabled) return;
    if (ai.logoObj) { removeLogo(); toast('Removed your logo file. The AI\'s version shows again.', 5000); return; }
    ui.logoBtn.disabled = true; $('[data-abl-logo-lbl]', ui.logoBtn).textContent = 'Adding your logo\u2026';
    ready().then(function () { return ai.logoImg ? ai.logoImg : fetchImage(apiBase() + '/bimg/' + ai.logo); }).then(function (r) {
      ai.logoImg = r;
      return new Promise(function (res, rej) { fabric.Image.fromURL(r.url, function (im) { if (im && im.width) res(im); else rej(new Error('logo')); }); });
    }).then(function (im) {
      targetFace();
      if (API.editFace() !== 'front') { API.set({ face: 'front' }); sync(); }
      if (!ai.found && ai.aiImg && ai.logoImg && ai.logoImg.img) {
        try { var hit = findLogo(ai.aiImg, ai.logoImg.img); if (hit) { ai.lb = hit; ai.cover = coverFor(hit, ai.logoImg.img); } } catch (er) {}
        ai.found = true;
      }
      var cb = ai.cover && aiBox(ai.cover.box), lbx = aiBox(ai.lb);
      if (cb && lbx && cb.w > 0 && cb.h > 0) {
        // keep the patch inside the safe line (so the dashed guide stays visible), but always over the AI's logo
        var sb = banner(), sa = safeArea(sb.c, sb.Wi, sb.Hi);
        var x0 = Math.min(Math.max(cb.x, sa.x), lbx.x), y0 = Math.min(Math.max(cb.y, sa.y), lbx.y);
        var x1 = Math.max(Math.min(cb.x + cb.w, sa.x + sa.w), lbx.x + lbx.w), y1 = Math.max(Math.min(cb.y + cb.h, sa.y + sa.h), lbx.y + lbx.h);
        cb = { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
        var rc = new fabric.Rect({ originX: 'center', originY: 'center', left: cb.x + cb.w / 2, top: cb.y + cb.h / 2, width: cb.w, height: cb.h, fill: ai.cover.color, stroke: null, strokeWidth: 0, selectable: false, evented: false, ablKind: 'cover', ablLabel: 'Cover over the AI logo' });
        fc.add(rc); ai.coverObj = rc;
      }
      var box = logoBox(im.width / im.height);
      look(im); im.set({ originX: 'center', originY: 'center', left: box.cx, top: box.cy, ablKind: 'image', ablLabel: 'Your logo (original file)', ablLogo: true });
      im.scale(box.w / im.width);
      ai.logoObj = im;
      place(im);
      ui.logoBtn.disabled = false; syncLogoBtn();
      toast('We put your original logo file over the AI\'s version. Drag it or its corners to line it up.', 10000, { label: 'Undo', run: removeLogo });
    }).catch(function () {
      ui.logoBtn.disabled = false; syncLogoBtn();
      toast('We couldn\'t load your logo file. Please try again, or upload it with the Artwork button.', 8000);
    });
  }

  // ---------- keyboard ----------
  function onKey(e) {
    if (!fc || document.querySelector('dialog[open]')) return;
    var ae = document.activeElement, o = fc.getActiveObject();
    var typing = (ae && /^(input|textarea|select)$/i.test(ae.tagName)) || (o && o.isEditing);
    var mine = !ae || ae === document.body || ui.root.contains(ae);
    if (!mine) return;
    var mod = e.metaKey || e.ctrlKey;
    if (mod && (e.key === 'z' || e.key === 'Z') && !typing && hist.list.length > 1) { e.preventDefault(); if (e.shiftKey) redo(); else undo(); return; }
    if (typing || !o || !editable()) return;
    if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); removeActive(); return; }
    if (mod && (e.key === 'd' || e.key === 'D')) { e.preventDefault(); objAction('duplicate'); return; }
    var step = e.shiftKey ? 2 : 0.25;
    if (e.key === 'ArrowLeft') o.left -= step; else if (e.key === 'ArrowRight') o.left += step;
    else if (e.key === 'ArrowUp') o.top -= step; else if (e.key === 'ArrowDown') o.top += step;
    else return;
    e.preventDefault(); o.setCoords(); fc.requestRenderAll(); changed(true);
  }

  // ---------- start ----------
  function watch() {
    var chip = $('[data-abb-chip-size]', ui.root);
    var onRender = function () { syncIdea(); if (fc) sync(); };
    if (chip && window.MutationObserver) new MutationObserver(onRender).observe(chip, { childList: true, characterData: true, subtree: true });
    var lc = API.layoutCanvas();
    if (lc && window.ResizeObserver) { try { new ResizeObserver(function () { if (fc) sync(); }).observe(lc); } catch (e) {} }
    window.addEventListener('resize', function () { if (fc) sync(); });
    if (ui.app && window.MutationObserver) {
      new MutationObserver(function () { if (fc) sync(); syncHist(); }).observe(ui.app, { attributes: true, attributeFilter: ['data-mode'] });
      var empty = $('[data-abx-empty]', ui.app);
      if (empty) new MutationObserver(function () { if (fc) syncEmpty(); }).observe(empty, { attributes: true, attributeFilter: ['hidden'] });
    }
    document.addEventListener('keydown', onKey);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ui.drawer && ui.drawer.classList.contains('is-open') && !document.querySelector('dialog[open]')) closeDrawer(); });
  }
  function boot() {
    if (booted) return true;
    API = window.ArdorBannerAPI;
    if (!API || !API.root) return false;
    if (!API.root.querySelector('.abx') && !API.root.classList.contains('abb--app') && !boot.waited) return false;
    booted = true;
    ui.root = API.root; ui.app = $('.abx', API.root);
    buildUi();
    watch();
    handoff();
    return true;
  }

  window.ArdorBannerLayers = { paint: paint, composite: composite, has: has, list: list, canvas: function () { return fc; }, ready: ready };

  if (!boot()) {
    var tries = 0;
    document.addEventListener('ardor:banner-api', function () { boot(); });
    var iv = setInterval(function () { tries++; if (tries > 20) boot.waited = true; if (boot() || tries > 150) clearInterval(iv); }, 100);
  }
})();
